module.exports = __webpack_public_path__ + "toBride2-we-y-n.cff44f28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-y-n.jpg
// module id = t1eP
// module chunks = 0